<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Learning Goal Quizzes</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Learning Goal Quizzes</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'LearningGoalQuizList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li>
                    <strong>Learning Goal</strong>
                    <span v-if="!_.isNil(value.learning_goal_id)">{{
                      pre.learning_goal_id[value.learning_goal_id]
                    }}</span>
                  </li>

                  <li><strong>Question</strong> {{ value.question }}</li>

                  <li>
                    <strong>Question type</strong> {{ value.question_type }}
                  </li>

                  <!-- <li><strong>Duration in seconds</strong> {{ value.duration_seconds }}</li> -->

                  <li>
                    <strong>Default mark</strong> {{ value.default_mark }}
                  </li>

                  <li><strong>Option 1</strong> {{ value.option_1 }}</li>

                  <li><strong>Option 2</strong> {{ value.option_2 }}</li>

                  <li><strong>Option 3</strong> {{ value.option_3 }}</li>

                  <li><strong>Option 4</strong> {{ value.option_4 }}</li>

                  <li><strong>Option 5</strong> {{ value.option_5 }}</li>

                  <li>
                    <strong>Correct options</strong> {{ value.correct_options }}
                  </li>

                  <li>
                    <strong>Display order</strong> {{ value.display_order }}
                  </li>

                  <li>
                    <strong>Is published</strong> {{ value.is_published }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "LearningGoalQuizShow",
  metaInfo: {
    title: "Learning Goal Quizzes | Dotlines",
  },
  data: () => ({
    value: {},
    pre: {
      learning_goal_id: [],
    },
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    learningGoalIdOptions: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-dropdown-options/10")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.learningGoalIdOptions().then((learning_goal_id) => {
        this.pre.learning_goal_id = learning_goal_id;
      });

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/learning_goal_quizzes/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
